/// <reference path="./types/index.ts" preserve="true" />
import { responsiveFontSizes as muiResponsiveFontSizes } from "@mui/material/styles";
import { getDesignTokens as getBigBangDesignTokens } from "./bigbang";
import { getDesignTokens as getIgniteRiddleDesignTokens } from "./ignite-riddle";
import { getDesignTokens as getIgniteUiDesignTokens } from "./ignite-ui";
export { getBackgroundToken, getButtonToken, getIconToken, getTextToken, getBorderToken, getToggleToken, getRangeSliderToken, getFieldToken, getProgressBarToken, getChipToken, getTableToken, getAlertToken } from "./ignite-riddle/fundations/palette/colorTokens";
export const getDesignTokens = (theme, mode)=>{
    switch(theme){
        case "bigbang":
            return getBigBangDesignTokens(mode);
        case "ignite-riddle":
            return getIgniteRiddleDesignTokens(mode);
        case "ignite-ui":
            return getIgniteUiDesignTokens(mode);
    }
};
export const responsiveFontSizes = (theme)=>{
    return muiResponsiveFontSizes(theme, {
        breakpoints: [
            "lg"
        ],
        disableAlign: true,
        factor: 1.5,
        variants: [
            "display2xl",
            "displayXl",
            "displayLg",
            "displayMd",
            "displaySm",
            "displayXs",
            "textXl",
            "textLg",
            "textMd",
            "textSm",
            "textXs",
            "text2xs"
        ]
    });
};

//# sourceMappingURL=index.js.map